<template>
	<div class="product-detail-page font-apercu-medium">
		<div class="fixed-header" style="border-bottom: 1rem solid #000;">
			<Header theme="light" @menu-open="onMenuOpen" @menu-close="onMenuClose" :show-border="false"
				:icon-color="'black'" />
		</div>

		<div class="main-content">
			<!-- Left Column: Images -->
			<div class="image-column">
				<div v-for="(item, index) in ProductDetail.Images" :key="'img-' + index">
					<div  v-if="item.ImageType !== 'main'"  class="image-wrapper" :class="{ 'no-border-top': index === 0 }">
						<img :src="item.ImageURL" alt="Sally Console Table Full View" />
					</div>
				</div>

				<!-- <div class="image-wrapper">
						<img :src="mainImg" alt="Sally Console Table Full View" />
					</div>
				<div class="image-wrapper">
					<img :src="detailImg" alt="Sally Console Table Detail View" />
				</div> -->
			</div>

			<!-- Right Column: Product Info -->
			<div class="info-column">
				<div class="info-sticky-wrapper">
					<h1 class="product-title">{{ProductDetail.ProductName}}</h1>

					<div class="product-specs">
						<div style="margin-left: 5rem;">
							<div class="spec-row" style="width: 100%;">
								<div class="spec-label">Dimension</div>
								<div class="spec-value">
									<span class="dim-item">L {{ProductDetail.DimensionLength}}</span>
									<span class="dim-item">W {{ProductDetail.DimensionWidth}}</span>
									<span class="dim-item">H {{ProductDetail.DimensionHeight}}</span>
								</div>
							</div>
							<div class="spec-row">
								<span class="spec-label">Material</span>
								<span class="spec-value">{{ProductDetail.Material}}</span>
							</div>
							<div class="spec-row">
								<span class="spec-label">Color</span>
								<span class="spec-value">{{ProductDetail.Color}}</span>
							</div>
						</div>

						<div v-if="ProductDetail.IsCustomisable" class="product-actions"
							:class="{ 'expanded': isCustomise }">
							<div class="actions-header">
								<label class="customise-checkbox">
									<input type="checkbox" v-model="isCustomise" />
									<span class="checkmark"></span>
									<span class="label-text">Customise</span>
								</label>

								<button v-if="!isCustomise" class="enquire-btn"
									@click="showEnquirePopup">[Enquire]</button>
							</div>

							<transition name="drawer">
								<div v-if="isCustomise" class="customise-form">
									<p class="customise-msg">
										You have selected Customise. Please specify your requirements below. (e.g. unique size, finish, or any other customisation)
									</p>

									<div class="dimension-limits">
										<div class="limit-row">
											<span class="limit-label">Minimum Dimension</span>
											<span class="limit-values">
												<span class="dim-val">L {{ProductDetail.MinimumLength}}</span>
												<span class="dim-val">W {{ProductDetail.MinimumHeight}}</span>
												<span class="dim-val">H {{ProductDetail.MinimumWidth}}</span>
											</span>
										</div>
										<div class="limit-row">
											<span class="limit-label">Maximum Dimension</span>
											<span class="limit-values">
												<span class="dim-val">L {{ProductDetail.MaximumLength}}</span>
												<span class="dim-val">W {{ProductDetail.MaximumWidth}}</span>
												<span class="dim-val">H {{ProductDetail.MaximumHeight}}</span>
											</span>
										</div>
									</div>
									<form @submit.prevent="showEnquirePopup">
										<input type="text" class="customise-input" v-model="CustomisationText"
											placeholder="Specify your customisation here." />

										<div class="actions-footer">
											<button class="enquire-btn" type="submit">[Enquire]</button>
										</div>
									</form>
								</div>
							</transition>
						</div>
					</div>



					<div class="product-sketch">
						<!-- Using a placeholder for the sketch as exact asset is not available -->
						<!-- Styled to look like a sketch/drawing -->
						<!-- <img :src="sketchImg" alt="Product Sketch" class="sketch-img" /> -->
					</div>
				</div>
			</div>
		</div>
		<!-- 登录面板 -->
		<Login :isOpen="showLogin" @close="closeLogin" />

		<Footer layout="about" :show-general-enquires="true" :show-studio="true" :show-instagram="true" />

		<!-- Customisation Popup (Appears after 5 seconds) -->
		<transition name="customise-anim">
			<div v-if="showCustomisePopup" class="customise-popup">
				<button class="close-btn" @click="closePopup">×</button>
				<div class="popup-content">
					<h3>Customisation</h3>
					<p>
						All denHolm pieces are made to order in our studio. 
						If you are looking for a unique size, finish, or any other customisation, 
						please select the Customise option.
					</p>
				</div>
			</div>
		</transition>

		<!-- Enquire Success Modal -->
		<transition name="enquire-anim">
			<div v-if="showEnquireModal" class="enquire-overlay" @click="closeEnquirePopup">
				<div class="enquire-modal" :class="{ 'shrinking': isShrinking }" @click.stop>
					<button class="modal-close-btn" @click="closeEnquirePopup">×</button>
					<div class="modal-content">
						<h3>Added to enquiry list!</h3>
						<a href="#" class="view-list-link" @click.prevent="openEnquiryList">View Your List</a>
					</div>
				</div>
			</div>
		</transition>

		<!--  List Drawer -->
		<Enquiry :is-open="showEnquiryDrawer" @close="closeEnquiryDrawer" />
	</div>
</template>

<script>
	import Header from '@/components/Header.vue'
	import Footer from '@/components/Footer.vue'
	import Enquiry from '@/components/Enquiry.vue'
	import Login from '@/components/Login.vue' // 登录组件
	import {
		showMessage
	} from '@/config/message' // 提示消息
	import {
		getProductDetail
	} from '@/api/product'
	import {
		getUser
	} from '@/config/auth' // 获取当前登录用户信息
	import {
		addToCart
	} from '@/api/Enquiry' // 购物车添加接口

	const mainImg = require('@/assets/product/TGT-Melissa-Marshall-27 1.jpg')
	const detailImg = require('@/assets/_DSC0544 2 4.jpg')
	const sketchImg = require('@/assets/product/table.png')
	const LOCAL_CART_KEY = 'pending_enquiry_items'

	export default {
		name: 'ProductDetail',
		components: {
			Header,
			Footer,
			Enquiry,
			Login
		},
		data() {
			return {
				menuOpen: false,
				mainImg,
				detailImg: detailImg,
				sketchImg: sketchImg,
				isCustomise: false,
				showCustomisePopup: false,
				showEnquireModal: false,
				isShrinking: false,
				showEnquiryDrawer: false,
				popupTimer: null,
				ProductDetail: {},
				CustomisationText: '',
				showLogin: false, // 控制登录面板显示
			}
		},
		mounted() {
			window.scrollTo(0, 0)
			this.popupTimer = setTimeout(() => {
				this.showCustomisePopup = true
			}, 5000)
			this.fetchProductDetail()

			// 监听登录成功事件（由 Login 组件触发）
			this.$root.$on('login-success', this.syncLocalCartToServer)
		},
		beforeDestroy() {
			document.body.style.overflow = ''
			if (this.popupTimer) clearTimeout(this.popupTimer)
			// 移除事件监听
			this.$root.$off('login-success', this.syncLocalCartToServer)
		},
		methods: {
			// 获取本地暂存的询价项
			getLocalCart() {
				const raw = localStorage.getItem(LOCAL_CART_KEY)
				return raw ? JSON.parse(raw) : []
			},

			// 保存本地暂存的询价项
			saveLocalCart(items) {
				localStorage.setItem(LOCAL_CART_KEY, JSON.stringify(items))
			},

			// // 添加产品到本地暂存
			// addToLocalCart(productId, customText) {
			//   let items = this.getLocalCart()
			//   const exists = items.some(item => item.ProductID === productId)
			//   if (exists) {
			//     showMessage('This product is already in your local enquiry list', 'info')
			//     return
			//   }
			//   // 存储完整的展示信息
			//   items.push({
			//     localId: Date.now() + Math.random(),
			//     ProductID: productId,
			//     image: this.ProductDetail.Images[0].ImageURL || '',  // 主图
			//     category: this.ProductDetail.CategoryName || '',
			//     name: this.ProductDetail.ProductName,
			//     customizationText: customText || ''
			//   })
			//   this.saveLocalCart(items)
			//   showMessage('Product added to local enquiry list. It will be synced after login.', 'success')
			// },
			
			// 添加辅助方法：获取主图URL
			getMainImage() {
			  if (!this.ProductDetail.Images || this.ProductDetail.Images.length === 0) {
			    return ''
			  }
			  // 查找 ImageType 为 "main" 的图片
			  const mainImage = this.ProductDetail.Images.find(img => img.ImageType === 'main')
			  // 如果没找到主图，则使用第一张图作为备选
			  return mainImage ? mainImage.ImageURL : this.ProductDetail.Images[0].ImageURL || ''
			},
			
			// 添加产品到本地暂存
			addToLocalCart(productId, customText) {
			    let items = this.getLocalCart()
			    const exists = items.some(item => item.ProductID === productId)
			    if (exists) {
			        // 改为与后端重复添加时一致的提示
			        showMessage('This product is already in your enquiry list', 'info')
			        return
			    }
			    items.push({
			        localId: Date.now() + Math.random(),
			        ProductID: productId,
			        image: this.getMainImage(),  // 使用辅助方法获取主图
			        category: this.ProductDetail.CategoryName || '',
			        name: this.ProductDetail.ProductName,
			        customizationText: customText || ''
			    })
			    this.saveLocalCart(items)
			    // 关键修改：与登录添加成功的提示保持一致
			    showMessage('Added to enquiry list!', 'success')
			},

			// 同步本地暂存到服务器
			async syncLocalCartToServer() {
				const items = this.getLocalCart()
				if (items.length === 0) return

				const user = getUser()
				if (!user) return

				let allSuccess = true
				for (const item of items) {
					try {
						const model = {
							ProductID: item.ProductID,
							UserID: user.UserID,
							CustomisationText: item.CustomisationText
						}
						const response = await addToCart(model)
						if (response.retCode !== 1) {
							allSuccess = false
							showMessage(`Failed to sync product ${item.ProductID}: ${response.retMsg}`, 'error')
						}
					} catch (err) {
						allSuccess = false
						console.error('Sync error', err)
					}
				}
				if (allSuccess) {
					showMessage(`Successfully synced ${items.length} item(s) to your enquiry list`, 'success')
				} else {
					showMessage('Some items failed to sync, please try again', 'error')
				}
				// 无论成功与否，清空本地暂存（避免重复同步）
				this.saveLocalCart([])
			},
			onMenuOpen() {
				this.menuOpen = true
				// Header handles body overflow
			},
			onMenuClose() {
				this.menuOpen = false
				// Header handles body overflow
			},
			closePopup() {
				this.showCustomisePopup = false
			},
			// 关闭登录面板
			closeLogin() {
				this.showLogin = false
			},
			// 添加到询价购物车
			async showEnquirePopup() {
				// 1. 判断是否登录
				const user = getUser()
				if (!user) {
					// // 未登录：暂存到本地
					// if (this.isCustomise && !this.CustomisationText) {
					// 	showMessage('Please enter your customization details', 'error')
					// 	return
					// }
					// this.addToLocalCart(this.ProductDetail.ProductID, this.CustomisationText)
					// // 可选：同时弹出登录面板，引导登录

					// // setTimeout(() => {
					// //   this.showLogin = true
					// // }, 2000)

					// return
					
					 // 未登录：暂存到本地，无任何登录弹窗提示
					        if (this.isCustomise && !this.CustomisationText) {
					            showMessage('Please enter your customization details', 'error');
					            return;
					        }
					        this.addToLocalCart(this.ProductDetail.ProductID, this.CustomisationText);
					        // 直接返回，不再弹出登录面板
					        return;
				}

				// 2. 已登录：正常添加
				if (this.isCustomise && !this.CustomisationText) {
					showMessage('Please enter your customization details', 'error')
					return
				}

				const model = {
					ProductID: this.ProductDetail.ProductID,
					UserID: user.UserID,
					CustomisationText: this.CustomisationText || ''
				}

				try {
					const response = await addToCart(model)
					if (response.retCode === 1) {
						this.showEnquireModal = true
					} else {
						showMessage(response.retMsg || 'Add to cart failed', 'error')
					}
				} catch (error) {
					console.error('Add to cart error:', error)
					showMessage('Network error, please try again', 'error')
				}
			},
			closeEnquirePopup() {
				this.showEnquireModal = false
				this.isShrinking = false
			},
			openEnquiryList() {
				// 1. Close the modal first (triggering the animation)
				this.showEnquireModal = false

				// 2. Open the drawer after animation completes
				setTimeout(() => {
					this.showEnquiryDrawer = true
				}, 300)
			},
			closeEnquiryDrawer() {
				this.showEnquiryDrawer = false
			},
			getProductIdFromRoute() {
				const raw = this.$route.query.productId
				if (!raw) return null
				const parsed = Number(raw)
				return isNaN(parsed) ? null : parsed
			},
			async fetchProductDetail() {
				const productId = this.getProductIdFromRoute()
				if (!productId) return

				try {
					const response = await getProductDetail(productId)
					console.log('Product detail response:', response)
					this.ProductDetail = response

				} catch (error) {
					console.error('Failed to load products:', error)
				}
			}
		},
		beforeDestroy() {
			document.body.style.overflow = ''
			if (this.popupTimer) {
				clearTimeout(this.popupTimer)
			}
		}
	}
</script>

<style scoped>
	.fixed-header {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 120rem;
		/* Fixed height to match header content + padding */
		z-index: 900;
		background-color: #fff;
		/* Ensure background is white to cover content */
	}

	.product-detail-page {
		width: 100%;
		min-height: 100vh;
		background-color: #fff;
		color: #000;
	}

	/* .menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
} */

	/* .sidebar-wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 35%;
    height: 100%;
    z-index: 1000;
    overflow: hidden;
} */

	.main-content {
		display: flex;
		width: 100%;
		height: auto;
		padding-top: 120rem;
		/* Space for fixed header */
	}

	/* Image Column */
	.image-column {
		width: 58%;
		/* Roughly 55% based on image */
	}

	.image-wrapper {
		width: 100%;
		/* margin-bottom: 2rem; */
		/* Small gap between images */
		border: 1rem solid #000;
	}

	.image-wrapper img {
		width: 100%;
		height: auto;
		display: block;
		object-fit: cover;
	}

	.no-border-top {
		border-top: none !important;
		/* 使用 !important 确保覆盖，或提高选择器优先级 */
	}

	/* Info Column */
	.info-column {
		width: 45%;
		padding: 106rem 89rem 0 111rem;
		position: relative;
		/* Ensure it doesn't scroll with main content if main content has overflow */
		height: calc(100vh - 120rem);
		position: sticky;
		top: 120rem;
		overflow-y: auto;
		/* Allow scrolling in info column */
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		/* Align content to top */

		/* Hide scrollbar */
		scrollbar-width: none;
		/* Firefox */
		-ms-overflow-style: none;
		/* IE and Edge */
	}

	.info-column::-webkit-scrollbar {
		display: none;
	}

	.info-sticky-wrapper {
		/* Removed sticky from here as parent is now sticky/fixed context */
		display: flex;
		flex-direction: column;
		gap: 40rem;
	}

	.product-title {
		/* Fallback, should be specific font if available */
		font-size: 24rem;
		font-weight: 500;
		margin: 0;
		letter-spacing: 0.5rem;
	}

	.product-specs {
		font-size: 16rem;
		color: #000;
		display: inline-flex;
		flex-direction: column;
		width: 100%;
		max-width: max-content;
		font-weight: 500;
	}

	.spec-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: max-content;
		max-width: max-content;
	}

	.spec-label {
		min-width: 180rem;
	}

	.spec-value {
		flex: 0 0 auto;
		display: inline-flex;
		width: max-content;
		max-width: max-content;
	}

	.dim-item {
		margin-right: 20rem;
	}

	/* Actions */
	.product-actions {
		display: flex;
		flex-direction: column;
		width: 100%;
		margin-top: 42rem;
		font-size: 16rem;
		/*
    display: inline-flex;
    width: max-content;
    max-width: max-content;
    */
	}

	.actions-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
	}

	.customise-checkbox {
		display: flex;
		align-items: center;
		cursor: pointer;
		user-select: none;
	}

	.customise-checkbox input {
		position: absolute;
		opacity: 0;
		cursor: pointer;
		height: 0;
		width: 0;
	}

	.checkmark {
		height: 14rem;
		width: 14rem;
		border: 1rem solid #000;
		border-radius: 2rem;
		margin-right: 10rem;
		position: relative;
		transition: background-color 0.2s;
		box-sizing: border-box;
	}

	.customise-checkbox input:checked~.checkmark {
		background-color: transparent;
	}

	.customise-checkbox input:checked~.checkmark:after {
		content: "";
		position: absolute;
		display: block;
		left: 50%;
		top: 50%;
		width: 10rem;
		height: 10rem;
		background-color: #000;
		transform: translate(-50%, -50%);
		border: none;
	}

	.customise-form {
		margin-top: 40rem;
		width: 100%;
		padding: 5rem;
		box-sizing: border-box;
	}

	.drawer-enter-active,
	.drawer-leave-active {
		transition: max-height 0.35s ease, padding-top 0.35s ease, padding-bottom 0.35s ease;
		overflow: hidden;
	}

	.drawer-enter,
	.drawer-leave-to {
		max-height: 0;
		padding-top: 0;
		padding-bottom: 0;
	}

	.drawer-enter-to,
	.drawer-leave {
		max-height: 600rem;
		padding-top: 20rem;
		padding-bottom: 20rem;
	}

	.customise-msg {
		font-size: 16rem;
		margin: 0 0 30rem 0;
		font-weight: 500;

	}

	.dimension-limits {
		margin-bottom: 70rem;
		font-size: 13rem;
		margin-left: 20rem;
	}

	.limit-row {
		display: flex;
		margin-bottom: 5rem;
	}

	.limit-label {
		width: 160rem;
		font-weight: 500;
	}

	.limit-values {
		display: flex;
	}

	.dim-val {
		margin-right: 20rem;
		min-width: 40rem;
	}

	.customise-input {
		width: 100%;
		border: none;
		border-bottom: 1rem solid #000;
		padding: 10rem 0;
		font-size: 16rem;
		outline: none;
		background: transparent;
		color: #999;
		margin-bottom: 20rem;
		font-weight: 500;
		font-family: 'Apercu-Medium', sans-serif;
	}

	.customise-input::placeholder {
		color: #ccc;
		font-family: 'Apercu-Medium', sans-serif;
	}

	.actions-footer {
		display: flex;
		justify-content: flex-end;
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateY(10rem);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	/* Enquire Modal */
	.enquire-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		/* Dim background */
		z-index: 3000;
		/* Highest priority */
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.enquire-modal {
		background-color: #fff;
		width: 437rem;
		height: 247rem;
		padding: 40rem;
		position: relative;
		text-align: center;
		box-shadow: 0 4rem 20rem rgba(0, 0, 0, 0.1);
		border: 1px solid #000;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.modal-close-btn {
		position: absolute;
		top: 10rem;
		right: 15rem;
		background: none;
		border: none;
		font-size: 24rem;
		cursor: pointer;
		color: #000;
		line-height: 1;
	}

	.modal-content h3 {
		font-size: 24rem;
		font-weight: 500;
		margin: 0 0 30rem 0;
		color: #000;
	}

	.view-list-link {
		font-size: 16rem;
		color: #000;
		text-decoration: underline;
		cursor: pointer;
		font-weight: 500;
	}

	.enquire-btn {
		background: none;
		border: none;
		cursor: pointer;
		font-size: 16rem;
		padding: 0;
		text-decoration: none;
		color: #000;
		font-weight: 600;
		font-family: 'Apercu-Medium', sans-serif;
	}

	/* Sketch */
	.product-sketch {
		margin-top: 60rem;
		width: 100%;
		display: flex;
		justify-content: center;
		padding-bottom: 70rem;
	}

	.sketch-img {
		width: 70%;
		height: auto;
		filter: grayscale(100%);
		/* Make it look more like a sketch */
	}

	/* Responsive */
	@media (max-width: 768px) {
		.main-content {
			flex-direction: column;
			padding-top: 80rem;
		}

		.image-column {
			width: 100%;
			padding-right: 0;
		}

		.info-column {
			width: 100%;
			padding: 40rem 20rem;
		}


		.info-sticky-wrapper {
			position: static;
		}

		.sidebar-wrap {
			width: 100%;
		}
	}

	/* Customisation Popup */
	.customise-popup {
		background-color: #f9f9f9;
		/* Off-white/light grey background */
		border: 1rem solid rgba(0, 0, 0, 1);
		width: 437rem;
		padding: 44rem 40rem;
		box-shadow: 0 4rem 10rem rgba(0, 0, 0, 0.1);
		position: fixed;
		bottom: 3%;
		left: 20rem;
		transform-origin: bottom left;
	}

	/* Customise Animation */
	.customise-anim-enter-active,
	.customise-anim-leave-active {
		transition: transform 0.3s ease-out, opacity 0.3s;
	}

	.customise-anim-enter,
	.customise-anim-leave-to {
		opacity: 0;
		transform: scale(0);
	}

	.close-btn {
		position: absolute;
		top: 10rem;
		right: 10rem;
		background: none;
		border: none;
		font-size: 20rem;
		cursor: pointer;
		line-height: 1;
		color: #000;
	}

	.popup-content h3 {
		font-size: 16rem;
		font-weight: 500;
		margin: 0 0 15rem 0;
		color: #000;
	}

	.popup-content p {
		font-size: 16rem;
		margin: 0;
		color: #333;
	}

	/* Enquire Success Modal Animation */
	.enquire-modal {
		/* transition: transform 0.3s ease-in, opacity 0.3s ease-in; */
		transform-origin: center;
	}

	.enquire-modal.shrinking {
		/* transform: scale(0.1);
    opacity: 0; */
		/* Handled by scale transition now */
	}

	/* Enquire Animation */
	.enquire-anim-enter-active,
	.enquire-anim-leave-active {
		transition: opacity 0.3s;
	}

	.enquire-anim-enter-active .enquire-modal,
	.enquire-anim-leave-active .enquire-modal {
		transition: transform 0.3s ease-out;
	}

	.enquire-anim-enter,
	.enquire-anim-leave-to {
		opacity: 0;
	}

	.enquire-anim-enter .enquire-modal,
	.enquire-anim-leave-to .enquire-modal {
		transform: scale(0);
	}
</style>